import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { Content } from 'lingo2-models';
import { ESizeCard, GalleryContentCardComponent } from '../gallery-content-card/gallery-content-card.component';

@Component({
  selector: 'app-gallery-content-group',
  standalone: true,
  imports: [LocaleSharedModule, CommonModule, GalleryContentCardComponent],
  templateUrl: './gallery-content-group.component.html',
  styleUrls: ['./gallery-content-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalleryContentGroupComponent {
  @Output() openCard = new EventEmitter<Content>();
  @Input() set groupItemContent(content: Content[]) {
    this._content = content;
    this.rowsContent = this.chunk(this._content, 1); // по 1 элементу в ряду
  }
  @Input() sizeCard: ESizeCard;
  public eSizeCard = ESizeCard;

  private _content: Content[];

  public rowsContent: Content[][];

  public chunk(arr, size) {
    return arr.reduce((acc, _, i) => (i % size ? acc : [...acc, arr.slice(i, i + size)]), []);
  }

  public trackByFn(index, item: Content[][] | Content[]) {
    return item;
  }

  public onOpenCard(e: Content) {
    this.openCard.emit(e);
  }
}
